import React from 'react';
import { string, shape, arrayOf } from 'prop-types';
import classNames from 'classnames';
import HeaderProposal from './components/header-proposal';
import BodyProposal from './components/body-proposal';

const namespace = 'ui-vip-box-credit-proposal';

const BoxCreditProposal = ({ className = '', header = null, body = null }) => (
  <div className={classNames(namespace, className)}>
    <HeaderProposal header={header} />
    <BodyProposal body={body} />
  </div>
);

BoxCreditProposal.propTypes = {
  className: string,
  header: shape({
    title: shape({
      text: string,
      color: string,
      font_size: string,
      font_family: string,
    }),
    image: shape({
      alt: string,
      id: string,
      src: string,
      src2x: string,
    }),
    tag_action: shape({}),
  }),
  body: shape({
    credit_options: arrayOf(
      shape({
        title: string.isRequired,
        subtitle: string.isRequired,
        value: string.isRequired,
      }),
    ),
    action: shape({
      label: shape({
        text: string.isRequired,
      }).isRequired,
      target: string,
    }).isRequired,
  }),
};

export default BoxCreditProposal;
